import ResponseModel from "../../models/response.model";
import axiosSetup from "../../utils/axiosSetup";

const basePath = "/factory/material-return";

export const replaceReturnRequestApi = async (data: {
  requestId: string;
  materialId: string;
  quantity: number;
  unit: string;
  reason: string;
}): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/create`;
    const res = await axiosSetup.post(path, data, {});
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getReplaceReturnRequestsApi = async (
  page: number,
  limit: number,
  status?: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/requests`;
    const res = await axiosSetup.get(path, {
      params: {
        page,
        limit,
        status,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const cancelReplaceReturnRequestApi = async (
  requestId: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/cancel/${requestId}`;
    const res = await axiosSetup.patch(path);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const reviewReplaceReturnRequestApi = async (
  requestId: string,
  status: "accepted" | "rejected",
  remark?: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/review/${requestId}`;
    const res = await axiosSetup.patch(path, { status, remark });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const resolveReplaceReturnRequestApi = async (
  requestId: string,
  resolution: "replace" | "repair" | "return",
  remark?: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/resolution/${requestId}`;
    const res = await axiosSetup.patch(path, { resolution, remark });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const assignNewStockToFloorApi = async (
  requestId: string,
  materialId: string,
  quantity: number,
  unit: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/assign-new-stock/${requestId}`;
    const res = await axiosSetup.patch(path, { materialId, quantity, unit });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const vendorDispatchForReplacementApi = async (
  requestId: string,
  vendorId: string,
  quantity: number,
  trasportCost: number,
  otherCosts: number,
  remark?: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/vendor-dispatch/${requestId}`;
    const res = await axiosSetup.patch(path, {
      vendorId,
      quantity,
      remark,
      trasportCost,
      otherCosts,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const receiveReplacementFromVendorApi = async (
  requestId: string,
  payload: {
    quantity: number;
    unit: string;
    vendorId: string;
    billNumber: string;
    transportCost: number;
    otherCosts: number;
    repairCost: number;
    remark?: string;
  },
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/vendor-receive/${requestId}`;
    const res = await axiosSetup.patch(path, payload);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const shrinkApi = async (
  requestId: string,
  quantity: number,
  unit: string,
): Promise<ResponseModel> => {
  try {
    const path = `${basePath}/shrink/${requestId}`;
    const res = await axiosSetup.patch(path, { quantity, unit });
    return res.data;
  } catch (error) {
    throw error;
  }
};
